<h1 class="flex justify-between"><span>Scholarship Count</span><span>School Year: <span>{{schoolYear | schoolYear}}</span></span></h1>
<mat-divider></mat-divider>
<p>
    The table lists all the scholarships active this school-year and how many applications they each have received.
    It also displays how many of the applications are completed, open/incomplete, how many have been selected as finalists, and how many have been awarded.
    Click the 'Manage' button to select the finalists and winners.
</p>

<div class="w-fit mt-[20px] mx-auto">
    <mat-form-field class="w-full">
        <mat-label>Search...</mat-label>
        <input matInput (keyup)="applyFilter($event)" [(ngModel)]="input">
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" matSort matSortDisableClear="true" (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="MasterID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Master ID</th>
            <td mat-cell *matCellDef="let row">{{row.MasterID}}</td>
        </ng-container>
        <ng-container matColumnDef="ScholarshipName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Scholarship Name</th>
            <td mat-cell *matCellDef="let row">{{row.ScholarshipName}}</td>
        </ng-container>
        <ng-container matColumnDef="CompletedCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Completed</th>
            <td mat-cell *matCellDef="let row">{{row.CompletedCount}}</td>
        </ng-container>
        <ng-container matColumnDef="OpenCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Open</th>
            <td mat-cell *matCellDef="let row">{{row.OpenCount}}</td>
        </ng-container>
        <ng-container matColumnDef="FinalistCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Finalist</th>
            <td mat-cell *matCellDef="let row">{{row.FinalistCount}}</td>
        </ng-container>
        <ng-container matColumnDef="AwardedCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Awarded</th>
            <td mat-cell *matCellDef="let row">{{row.AwardedCount}}</td>
        </ng-container>
        <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let row">
                <button mat-raised-button type="button" [routerLink]="['/manage-scholarship', row.ScholarshipID]">Manage</button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [ngClass]="{ evenRows: even }"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-red-500 text-center" colspan="7">No data found</td>
        </tr>
    </table>
    <mat-divider></mat-divider>
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 50, 100, 500]" (page)="handlePageEvent($event)"></mat-paginator>
</div>